/* Others */
import { makeFetchActionCreators, makeFetchActionTypes } from "../../../utils";

export const ACTION_TYPES_BASE_NAME = "player/heartbeat";
export const PULSE_STREAM_HEARTBEAT = `${ACTION_TYPES_BASE_NAME}/PULSE`;
export const actionTypes = makeFetchActionTypes(ACTION_TYPES_BASE_NAME);
const actionCreators = makeFetchActionCreators(ACTION_TYPES_BASE_NAME);
export const { fetch: fetchStreamHeartbeat, reset: resetStreamHeartbeat } = actionCreators;

export const pulseStreamHeartbeat = (payload) => ({
  type: PULSE_STREAM_HEARTBEAT,
  payload
});
